import axios, { AxiosResponse } from 'axios';
import { getHostApi, getRequestConfig, getShopInfo } from "../utils";
import { CustomerType } from '../components/mon-compte/iMonCompte';
import { ResponseData } from '../interfaces-base';

export async function fetchCustomerTypes(): Promise<AxiosResponse<ResponseData<CustomerType[]>>> {
  return axios.get<ResponseData<CustomerType[]>>(`${getHostApi()}/shops/${getShopInfo()?.idBoutique ?? 0}/customer-types`);
}

export async function fetchHasFeature(name: string): Promise<AxiosResponse<{feature: boolean;}>> {
  return axios.get(`${getHostApi()}/shops/features/${name}`, getRequestConfig())
}